/** 편집기와 공개 렌더러가 공유하는 허용 서식. 기본값은 사이트 CSS를 따른다. */
export const CMS_FONT_SIZES = [14, 16, 18, 20, 24, 28, 32] as const;
export const CMS_LINE_HEIGHTS = [1.2, 1.5, 1.8, 2, 2.4] as const;
export const CMS_PARAGRAPH_SPACINGS = [0, 8, 16, 24, 32] as const;
export const CMS_IMAGE_WIDTHS = [25, 50, 75, 100] as const;

export function cmsFontSize(value: unknown): string | null {
  if (typeof value !== "string") return null;
  return CMS_FONT_SIZES.some((size) => value === `${size}px`) ? value : null;
}
export function cmsLineHeight(value: unknown): number | null {
  if (typeof value !== "number" && typeof value !== "string") return null;
  return CMS_LINE_HEIGHTS.find((size) => String(size) === String(value)) ?? null;
}
export function cmsParagraphSpacing(value: unknown): string | null {
  if (typeof value !== "string") return null;
  return CMS_PARAGRAPH_SPACINGS.some((size) => value === `${size}px`) ? value : null;
}
export function cmsImageWidth(value: unknown): string | null {
  if (typeof value !== "string") return null;
  return CMS_IMAGE_WIDTHS.some((size) => value === `${size}%`) ? value : null;
}
export function cmsImageAlign(value: unknown): "left" | "center" | "right" | null {
  return value === "left" || value === "center" || value === "right" ? value : null;
}
export function cmsImageStyle(attrs: Record<string, unknown>) {
  const width = cmsImageWidth(attrs.displayWidth);
  const align = cmsImageAlign(attrs.imageAlign);
  return {
    ...(width ? { width, maxWidth: "100%", height: "auto" } : {}),
    ...(align ? {
      display: "block",
      marginLeft: align === "left" ? "0" : "auto",
      marginRight: align === "right" ? "0" : "auto",
    } : {}),
  };
}
